<template>
  <div v-if="bridgeError" class="container is-max-desktop">
    <div class="notification is-danger login-notice">
      <p>{{ bridgeError }}</p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useClerkBridge } from '@/auth/useClerkBridge'

export default defineComponent({
  setup() {
    const { bridgeError } = useClerkBridge()
    return { bridgeError }
  }
})
</script>
